module.exports = __webpack_public_path__ + "media/images/landing__bg-78603ef14c8fc0e7f899de818d755302.jpg";